/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Search_Guides_Gridcraft_Online_Sections_2_Paragraphs_0Inputs */

const en_gc_search_guides_gridcraft_online_sections_2_paragraphs_0 = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Online_Sections_2_Paragraphs_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Do not use a refresh or a reopened editor URL as a saving test. A fresh session can start from the original sample. The downloaded workbook is the portable copy you can move to a desktop app, another browser or another person.`)
};

const zh_gc_search_guides_gridcraft_online_sections_2_paragraphs_0 = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Online_Sections_2_Paragraphs_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`不要通过刷新页面或重新打开编辑器网址来验证保存。新会话可能重新载入原始示例。下载的工作簿才是可以带到桌面应用、其他浏览器或分享给他人的文件。`)
};

/**
* | output |
* | --- |
* | "Do not use a refresh or a reopened editor URL as a saving test. A fresh session can start from the original sample. The downloaded workbook is the portable c..." |
*
* @param {Gc_Search_Guides_Gridcraft_Online_Sections_2_Paragraphs_0Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_search_guides_gridcraft_online_sections_2_paragraphs_0 = /** @type {((inputs?: Gc_Search_Guides_Gridcraft_Online_Sections_2_Paragraphs_0Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Search_Guides_Gridcraft_Online_Sections_2_Paragraphs_0Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_search_guides_gridcraft_online_sections_2_paragraphs_0(inputs)
	return zh_gc_search_guides_gridcraft_online_sections_2_paragraphs_0(inputs)
});
export { gc_search_guides_gridcraft_online_sections_2_paragraphs_0 as "gc.search_guides.gridcraft_online.sections.2.paragraphs.0" }